/**
 * HQ API client - 본부 백엔드 전용 axios 인스턴스.
 *
 * - baseURL: 환경변수 REACT_APP_HQ_API_URL 사용
 *   (개발: http://localhost:8004, 임시 NTD: http://100.80.98.113:8004)
 * - 자동 토큰 첨부 (localStorage 'hq_access_token')
 * - 401 응답 시 자동 로그아웃
 */
import { HQ_BASE } from '../constants';
import axios from 'axios';

// 운영: 같은 origin (newattend.com → nginx /api/ → backend:8000)
// 로컬: localhost:8004 (admission-only)
const HQ_API_URL =
  process.env.REACT_APP_HQ_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:8004'
    : typeof window !== 'undefined'
      ? window.location.origin
      : 'http://100.80.98.113:8004');

export const HQ_TOKEN_KEY = 'hq_access_token';
export const HQ_REFRESH_KEY = 'hq_refresh_token';
export const HQ_USER_KEY = 'hq_user';

const hqApi = axios.create({
  baseURL: HQ_API_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// 요청 인터셉터: 토큰 자동 첨부
hqApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(HQ_TOKEN_KEY);
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 응답 인터셉터: 401이면 토큰 정리 + 로그인으로
hqApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(HQ_TOKEN_KEY);
      localStorage.removeItem(HQ_REFRESH_KEY);
      localStorage.removeItem(HQ_USER_KEY);
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith(`${HQ_BASE}/login`)) {
        window.location.href = `${HQ_BASE}/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default hqApi;
export { HQ_API_URL };
